export const isApplicationLoading = ({ user }) => user.isApplicationLoading;
export const isAuthenticated = ({ user }) => user.isAuthenticated;
export const userInfo = ({ user }) => user.info;
